<template>
	<span class="fa" :class="icon"></span>
</template>

<script>

export default {

	props: {
		default: {
			type: String,
			required: true,
		},

		conditionalIcon: {
			type: String,
			required: true,
		},

		condition: {
			type: Boolean,
			required: true,
		}
	},

	computed: {

		icon() {
			return this.condition ? this.conditionalIcon : this.default;
		},

	},

};

</script>
